// react
import React from 'react'

// css
import '../../css/components/FAQ.styl'

// dependencies
import { Icon, Card, Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'

// component
class FAQ extends React.Component {
  renderLink(text, href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <p className="faq__link">{text}</p>
      </a>
    )
  }

  render() {
    const { onClose } = this.props
    const links = [
      {
        text: 'How to use Audience Insights',
        url:
          'https://sharethis.atlassian.net/wiki/spaces/PT/pages/233340975/How+To+Use+Audience+Insights+Demo+Guide',
      },
      {
        text: 'Best Practices',
        url:
          'https://sharethis.atlassian.net/wiki/spaces/RI/pages/400490524/Best+Practices+For+Custom+Insight+Slides',
      },
      {
        text: 'Frequently Asked Questions',
        url: 'https://sharethis.atlassian.net/wiki/spaces/PT/pages/16416770/Audience+Insights+FAQs',
      },
      {
        text: 'Watch How To Videos',
        url: 'https://sharethis.atlassian.net/wiki/spaces/RI/pages/405667872/How+To+Videos',
      },
    ]

    return (
      <div className="faq">
        <div className="faq__bg" onClick={onClose} />
        <Card className="st-faq__box">
          {/* general information */}
          <div className="faq__header">
            <h4>Information center</h4>
            <Button onClick={onClose} theme={BUTTON_THEME.GHOST} className="faq__header--button">
              <Icon color="#3d3d3d" icon="delete" type="fill" width="16px" height="16px" />
            </Button>
          </div>

          {/* help */}
          <For each="link" of={links}>
            {this.renderLink(link.text, link.url)}
          </For>
        </Card>
      </div>
    )
  }
}

// export
export default FAQ
